'use client'

import dynamic from 'next/dynamic'

import { newsPageQuery } from '@otomoro/sanity/lib/queries';
import { QueryResponseInitial, useQuery } from '@sanity/react-loader';
import { SanityDocument } from 'next-sanity';

// Re-exported components using next/dynamic ensures they're not bundled
// and sent to the browser unless actually used, with draftMode().enabled.

export const NewsDetailsPage = dynamic(() => import('./NewsDetailsPage'))

export default function NewsDetailsPagePreview({
  initial,
  slug,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
  slug: string;
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    newsPageQuery,
    {
      slug,
    },
    { initial }
  );

	return data ? (
    <NewsDetailsPage data={data as any} />
  ) : (
    <div className="bg-red-100">No page found</div>
  );
}